/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { ApiFrontendInternalLinkingCityLocaleRetrieve200 } from './model/apiFrontendInternalLinkingCityLocaleRetrieve200';

export const apiFrontendInternalLinkingCityLocaleRetrieve = (
  countryCode: string,
  language: string,
  regionSlug: string,
  citySlug: string,
  signal?: AbortSignal
) => {
  return HTTP<ApiFrontendInternalLinkingCityLocaleRetrieve200>({
    url: `/api/v7/frontend/internal-linking/${countryCode}/${language}/${regionSlug}/${citySlug}/`,
    method: 'GET',
    signal,
  });
};

export const getApiFrontendInternalLinkingCityLocaleRetrieveQueryKey = (
  countryCode?: string,
  language?: string,
  regionSlug?: string,
  citySlug?: string
) => {
  return [
    `/api/v7/frontend/internal-linking/${countryCode}/${language}/${regionSlug}/${citySlug}/`,
  ] as const;
};

export const getApiFrontendInternalLinkingCityLocaleRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiFrontendInternalLinkingCityLocaleRetrieve>>,
  TError = ErrorType<void>
>(
  countryCode: string,
  language: string,
  regionSlug: string,
  citySlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiFrontendInternalLinkingCityLocaleRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiFrontendInternalLinkingCityLocaleRetrieveQueryKey(
      countryCode,
      language,
      regionSlug,
      citySlug
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiFrontendInternalLinkingCityLocaleRetrieve>>
  > = ({ signal }) =>
    apiFrontendInternalLinkingCityLocaleRetrieve(
      countryCode,
      language,
      regionSlug,
      citySlug,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(countryCode && language && regionSlug && citySlug),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiFrontendInternalLinkingCityLocaleRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiFrontendInternalLinkingCityLocaleRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFrontendInternalLinkingCityLocaleRetrieve>>
>;
export type ApiFrontendInternalLinkingCityLocaleRetrieveQueryError = ErrorType<void>;

export function useApiFrontendInternalLinkingCityLocaleRetrieve<
  TData = Awaited<ReturnType<typeof apiFrontendInternalLinkingCityLocaleRetrieve>>,
  TError = ErrorType<void>
>(
  countryCode: string,
  language: string,
  regionSlug: string,
  citySlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiFrontendInternalLinkingCityLocaleRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiFrontendInternalLinkingCityLocaleRetrieveQueryOptions(
    countryCode,
    language,
    regionSlug,
    citySlug,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
